module.exports = __webpack_public_path__ + "static/media/4.09749dac.PNG";